import {
  useUserInfoQuery,
  USER_ROLE,
  userHasRequiredRoles,
} from "@/features/shared/features/authentication";

const WithRole = (WrappedComponent: React.ComponentType, roles: USER_ROLE[]) => {
  const WithRole = () => {
    const userInfo = useUserInfoQuery();

    if (userInfo.isLoading) {
      return null;
    }

    const userHasCorrectRoles = userHasRequiredRoles(userInfo.data?.roles ?? [], roles);

    if (!userHasCorrectRoles) {
      throw new Error("User does not have the correct roles to access this page");
    }

    return <WrappedComponent />;
  };

  return WithRole;
};

export default WithRole;
